import { Box, Typography } from '@mui/material'
import React from 'react'

export interface PreviewHeaderProps {
  show?: boolean
}

const PreviewHeader = (props: PreviewHeaderProps) => {
  return props.show ? <Box sx={{
    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',
    width: '100vw', position: 'fixed', top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.1)', zIndex: 1000
  }}>
    <Typography variant="h1" sx={{ color: 'white' }}>Preview</Typography>
  </Box>
    : <></>
}

export default PreviewHeader